import React from 'react';

function EmptyViewport() {
  return <div></div>;
}

export default EmptyViewport;
